import React, { Component } from "react";
import { connect } from "react-redux";
import { Checkbox, Typography, Space } from "antd";
import axios from "axios";
import moment from "moment";
import {
  ModalItem,
  InputItem,
  DatePickerItem,
  ButtonItem,
} from "../../../../Components/Items";
import SelectLeadsItem from "../../../../Components/SelectLeadsItem";

const { Text } = Typography;

class ModalTarea extends Component {
  estadoInicial = {
    titulo: "",
    descripcion: "",
    fechaInicio: null,
    fechaFin: null,
    todoElDia: false,
    leadId: null,
    guardando: false,
    error: null,
  };

  state = { ...this.estadoInicial };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      if (this.props.tareaEditando) {
        const t = this.props.tareaEditando;
        this.setState({
          ...this.estadoInicial,
          titulo: t.title ?? "",
          descripcion: t.descripcion ?? "",
          fechaInicio: t.start ? moment(t.start) : null,
          fechaFin: t.end ? moment(t.end) : null,
          todoElDia: t.allDay ?? false,
          leadId: t.leadId ?? this.props.leadIdFijo ?? null,
        });
      } else {
        this.setState({
          ...this.estadoInicial,
          leadId: this.props.leadIdFijo ?? null,
        });
      }
    }
  }

  handleGuardar = () => {
    const { titulo, fechaInicio, fechaFin, todoElDia, descripcion, leadId } =
      this.state;
    const { headersToken, empresaId } = this.props;

    // Validaciones
    if (!titulo.trim()) {
      this.setState({ error: "El título es obligatorio." });
      return;
    }

    if (!fechaInicio && fechaFin) {
      this.setState({
        error: "No puedes agregar fecha de fin sin fecha de inicio.",
      });
      return;
    }

    this.setState({ guardando: true, error: null });

    axios
      .post(
        "leads/guardarTarea",
        {
          empresaId,
          tareaId: this.props.tareaEditando?.id ?? null,
          leadId: leadId || null,
          titulo: titulo.trim(),
          descripcion,
          fechaInicio: fechaInicio ? fechaInicio.toISOString() : null,
          fechaFin: fechaFin ? fechaFin.toISOString() : null,
          todoElDia,
        },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data?.success === 2) {
          this.props.onGuardado?.();
          this.props.onCancel();
        } else {
          this.setState({ error: res.data?.message || "Error al guardar." });
        }
      })
      .catch(() => {
        this.setState({ error: "Error de conexión." });
      })
      .finally(() => {
        this.setState({ guardando: false });
      });
  };

  render() {
    const { visible, onCancel, headersToken, empresaId } = this.props;
    const {
      titulo,
      descripcion,
      fechaInicio,
      fechaFin,
      todoElDia,
      leadId,
      guardando,
      error,
    } = this.state;

    return (
      <ModalItem
        title={this.props.tareaEditando ? "Editar tarea" : "Nueva tarea"}
        visible={visible}
        onCancel={onCancel}
        spinning={guardando}
        footer={false}
        width="500px"
        paddingTop
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            paddingTop: 12,
          }}
        >
          {/* Título */}
          <div>
            <Text
              strong
              style={{ fontSize: 12, display: "block", marginBottom: 4 }}
            >
              Título <span style={{ color: "#ff4d4f" }}>*</span>
            </Text>
            <InputItem
              placeholder="Título de la tarea"
              value={titulo}
              onChange={(e) =>
                this.setState({ titulo: e.target.value, error: null })
              }
              onPressEnter={this.handleGuardar}
            />
          </div>

          {/* Descripción */}
          <div>
            <Text
              strong
              style={{ fontSize: 12, display: "block", marginBottom: 4 }}
            >
              Descripción
            </Text>
            <InputItem
              placeholder="Descripción (opcional)"
              value={descripcion}
              onChange={(e) => this.setState({ descripcion: e.target.value })}
            />
          </div>

          {/* Lead asociado */}
          <div>
            <Text
              strong
              style={{ fontSize: 12, display: "block", marginBottom: 4 }}
            >
              Lead asociado
            </Text>
            <SelectLeadsItem
              key={
                this.props.tareaEditando?.id ?? this.props.leadIdFijo ?? "nuevo"
              }
              value={leadId}
              onChange={(id) => this.setState({ leadId: id })}
              empresaId={empresaId}
              headersToken={headersToken}
              placeholder="Buscar lead..."
              allowClear
              disabled={!!this.props.leadIdFijo}
            />
          </div>

          {/* Todo el día */}
          <Checkbox
            checked={todoElDia}
            onChange={(e) =>
              this.setState({
                todoElDia: e.target.checked,
                // Al marcar todo el día limpiamos horas
                fechaInicio: fechaInicio
                  ? moment(fechaInicio).startOf("day")
                  : null,
                fechaFin: fechaFin ? moment(fechaFin).startOf("day") : null,
              })
            }
            style={{ fontSize: 12 }}
          >
            Evento de todo el día
          </Checkbox>

          {/* Fechas */}
          <Space style={{ width: "100%", display: "flex" }}>
            <div style={{ flex: 1 }}>
              <Text
                type="secondary"
                style={{ fontSize: 11, display: "block", marginBottom: 4 }}
              >
                Fecha inicio
              </Text>
              <DatePickerItem
                placeholder="Fecha inicio"
                style={{ width: "100%" }}
                value={fechaInicio}
                onChange={(date) =>
                  this.setState({ fechaInicio: date, error: null })
                }
                format={todoElDia ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm"}
                showTime={!todoElDia}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Text
                type="secondary"
                style={{ fontSize: 11, display: "block", marginBottom: 4 }}
              >
                Fecha fin
              </Text>
              <DatePickerItem
                placeholder="Fecha fin"
                style={{ width: "100%" }}
                value={fechaFin}
                onChange={(date) => this.setState({ fechaFin: date })}
                format={todoElDia ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm"}
                showTime={!todoElDia}
                // No se puede seleccionar fecha fin sin inicio
                disabled={!fechaInicio}
                disabledDate={(current) =>
                  fechaInicio
                    ? current && current < moment(fechaInicio).startOf("day")
                    : false
                }
              />
            </div>
          </Space>

          {/* Error */}
          {error && (
            <Text type="danger" style={{ fontSize: 12 }}>
              {error}
            </Text>
          )}

          {/* Footer manual */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              paddingTop: 4,
              paddingBottom: 8,
            }}
          >
            <ButtonItem danger onClick={onCancel}>
              Cancelar
            </ButtonItem>
            <ButtonItem negro2 onClick={this.handleGuardar} loading={guardando}>
              Guardar tarea
            </ButtonItem>
          </div>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalTarea);
